import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import $ from 'jquery';
import './signin.css';
import { createUserWithEmailAndPassword, getAuth } from 'firebase/auth';
import axios from 'axios';
import { app } from '../firebase/firebase-config';
import { MultiSelect } from 'react-multi-select-component';
import { userSchema as schema } from './schema.js';
// import {TextInput} from 'react-native';
const auth = getAuth(app);

const renderError = (message) => <p className="warning">{message}</p>;
const SignUp = () => {
	const [loading, setLoading] = useState(false);
	const [loggedIn, setLoggedIn] = useState(false);
	const [selectedServices, setSelectedServices] = useState([]);
	const [format, setFormat] = useState(0);
	const [options, setOptions] = useState([]);
	//testing.
	const [servicePrices, setServicePrices] = useState([]);
	//a reusable call to get the services listing from the API. 
	const getServices = () => {
		axios.get(`${process.env.REACT_APP_API_BASE_URL}/enabledServices`)   //not sure yet. Just added in
			.then((response) => {
				const responseOptions = response.data.map((service) => {
					return { label: service.name, value: service.id };
				});
				setOptions(responseOptions);
			});
	};

	//a function to set up an an array to assign to the servicePrices useState
	const setNewServicePrice = (newService, servicePrices) => {
		var temp = servicePrices;
		temp.push(newService);
		setServicePrices(temp);
	}
	const history = useNavigate(); // let's us get sent to another page or something

	auth.onAuthStateChanged((user) => {     //set it so that the current user is the one you will be logged in the next time.
		setLoggedIn(user);
	});

	if (loggedIn) {
		return (
			<div className="loaderContainer">
				<div className="loader"></div>
			</div>
		)
	} else {
		return (
			<div className='hero'>
				<div className="triangle">
					<div style={{ display: 'flex' }} className="container">
						<Formik
							initialValues={{
								firstname: "",
								lastname: "",
								email: "",
								password: "",
								confirmPassword: "",
								isHealer: false,
								services: [],
								format: 0,
								description: "",
								terms: false,
								// servicePrices: []
							}}
							validationSchema={schema}

							onSubmit={(values, actions) => {
								//TODO: If registration fails due to it failing against the schema, alert the user
								//setSubmitting keeps track of whether you are in the midst of submitting data
								actions.setSubmitting(true);
								(async () => {
									// selectedServices.forEach((service) => {
									// 	values.services.push(service.value)
									// })

									// servicePrices.length > 0 ? servicePrices.forEach((price) => {
									// 	values.servicePrices.push(price.value)
									// }) :
									// values.servicePrices = null
									// servicePrices.map((price)=> {
									// 	values.servicePrices.push(price.value);
									// })
									//the client-side method from firebase which handles user creation. 
									//there should be a fallback for this if the user db entry is created and the firebase
									//user is unable to be created, or vice-versa
									createUserWithEmailAndPassword(auth, values.email, values.password)
										.then((userCredential) => {
											// Signed in 
											values.fbid = userCredential.user.id
											const user = userCredential.user.getIdToken()
												.then((token) => {
													document.cookie = '__session=' + token + ';max-age=3600';
												})
										})
										.then(() => {
											console.log(values);
											//the database entry should only happen after a successful firebase insert
											axios.post('http://localhost:8080/users', values)
												.then((response) => {
													if (response.data) {
														console.log(response.data);
													}
													setLoading(false);
													actions.setSubmitting(false);
													if (response.data.url == null) {
														window.location.assign('/');
													}
													else {
														window.location.assign(response.data.url)   //not sure yet.
													}

												})
											// .then(() => {
											// 	//window.location.assign('/');

											// })
										})

										.catch((error) => {
											console.log("User API Creation Error: " + error);
											alert(error);
											alert("TODO: Replace this with user friendly error messages");
										})
								})();
							}}
						>
							{({ handleSubmit, values }) => (
								<div className="signupFormContainer">
									<Form
										className="signupForm"
										onSubmit={handleSubmit}
									>
										<div className="signupPageContainer">
											<p className="" style={{ marginBottom: '1px', marginTop: '15px' }}>First Name</p>
											<Field
												type="text"
												id="firstname"
												name="firstname"
												label="First Name"
												autoComplete="fname"
												placeholder="Enter your first name"

												autoFocus
												required
											/>
											<ErrorMessage name="firstname" render={renderError} />

											<p className="" style={{ marginBottom: '1px', marginTop: '15px' }}>Last Name</p>
											<Field
												type="text"
												id="lastname"
												name="lastname"
												label="Last Name"
												autoComplete="lname"
												placeholder="Enter your last name"

												required
											/>
											<ErrorMessage name="lastname" render={renderError} />

											<p className="" style={{ marginBottom: '1px', marginTop: '15px' }}>Email</p>
											<Field
												id="email"
												label="Email"
												type="email"
												name="email"
												autoComplete="email"
												placeholder="Enter your email"
												required
											/>
											<ErrorMessage name="email" render={renderError} />

											<p className="" style={{ marginBottom: '1px', marginTop: '15px' }}>Password</p>
											<Field
												label="Password"
												type="password"
												name="password"
												id="password"
												autoComplete="current-password"
												placeholder="Enter your password"
												required
											/>
											<ErrorMessage name="password" render={renderError} />

											<p className="" style={{ marginBottom: '1px', marginTop: '15px' }}>Confirm Password</p>
											<Field
												label="Confirm Password"
												type="password"
												name="confirmPassword"
												id="confirmPassword"
												autoComplete="current-password-confirm"
												required
											/>
											<ErrorMessage name="confirmPassword" render={renderError} />

											<p className="" style={{ marginBottom: '1px', marginTop: '15px' }}>Address</p>
											<Field
												label="Address"
												type="text"
												name="address"
												id="address"
												autoComplete="address"
												placeholder="Enter your address"
											/>
											<ErrorMessage name="address" render={renderError} />

											<p className="" style={{ marginBottom: '1px', marginTop: '15px' }}>City</p>
											<Field
												label="City"
												type="text"
												name="city"
												id="city"
												autoComplete="city"
												placeholder="Enter your city"
											/>
											<ErrorMessage name="city" render={renderError} />

											<p className="" style={{ marginBottom: '1px', marginTop: '15px' }}>Province:</p>
											<Field
												label="Province"
												type="text"
												name="province"
												id="province"
												autoComplete="province"
												placeholder="Enter your province"
											/>
											<ErrorMessage name="province" render={renderError} />

											<p className="" style={{ marginBottom: '1px', marginTop: '15px' }}>Country:</p>
											<Field
												label="Country"
												type="text"
												name="country"
												id="country"
												autoComplete="country"
												placeholder="Enter your country"
											/>
											<ErrorMessage name="country" render={renderError} />

											<p className="" style={{ marginBottom: '1px', marginTop: '15px' }}>Postal Code:</p>
											<Field
												label="Postal code"
												type="text"
												name="postalCode"
												id="postalCode"
												autoComplete="postalCode"
												placeholder="Enter your postal code"
											/>
											<ErrorMessage name="postalCode" render={renderError} />

											<div className="nonTextSignupForm">
												<div style={{ backgroundColor: 'darkseagreen' }} className="selectBox">
													<p>Are you a healer?</p>
													<Field
														name="isHealer"
														type="checkbox"
														id="isHealer"
													/>
													<ErrorMessage name="isHealer" render={renderError} />
												</div>
												{
													values.isHealer ? (
														<HealerOptions
															getServices={getServices}
															selectedServices={selectedServices}
															setSelectedServices={setSelectedServices}
															options={options}
															servicePrices={servicePrices}
															setServicePrices={setServicePrices}
														/>
													) : null
												}
												<div className="selectBox">
													<p>I accept the terms and conditions</p>
													<Field
														className="termsCheckbox"
														type="checkbox"
														name="terms"
														required
													/>
													<ErrorMessage name="terms" render={renderError} />
												</div>
												<button type="submit" className="btn--login">Register</button>
											</div>
										</div>
									</Form>
									<div className="signin">
										<a href="/login">Already have an account?<br />Sign in</a>
									</div>
								</div>
							)}
						</Formik>
					</div>
				</div>
			</div>
		);
	}
}

/*similarly to the Account edit page, Healer options defines the fields related only to those users who wish to be healers and listed in the healer search. */
const HealerOptions = (props) => {
	var priceOrder = -1;
	//on render, fetches the services from the service API, limiting network calls until needed. 
	useEffect(() => {
		props.getServices()
	}, [])

	return (
		<>
			<p style={{ marginBottom: '1px', marginTop: '20px' }}>Services Offered:</p>
			<Field
				name="services"
				as={MultiSelect}
				options={props.options}
				value={props.selectedServices}
				onChange={props.setSelectedServices}
			>

			</Field>
			<ErrorMessage name="services" render={renderError} />
			<p>Price of services in 1 hour: </p>
			{props.selectedServices.map(service => {
				priceOrder++;
				return (
					<>
						<Field
							key={service}
							type="text"
							id="servicePrices"
							name={'servicePrices[' + priceOrder + ']'}
							label="Service Prices"
							autoComplete="sprices"
							autoFocus
							required
						//onChange = {props.setServicePrices}
						/>
						<ErrorMessage name="servicePrices" render={renderError} />
					</>
				)
			})}
			<ErrorMessage name="services" render={renderError} />

			<p>Delivery Format: </p>
			<Field
				name="format"
				as="select"
				id="format"
			>
				<option value={0} label="Both Online and In-Person"></option>
				<option value={1} label="In-Person Only"></option>
				<option value={2} label="Online Only"></option>
			</Field>
			<ErrorMessage name="format" render={renderError} />

			<p style={{ marginBottom: '1px', marginTop: '20px' }}>Personal Description:</p>
			<Field
				name="description"
				as="textarea"
				id="signUpDescription"
			/>
			<ErrorMessage name="description" render={renderError} />

			<br />
		</>
	)
}

export default SignUp;